import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import { Link } from "react-router-dom";

const addBlogEndpoint = ApiEndpoints.adminBlogs.blogCreate;
const authorListEndpoint = ApiEndpoints.autor.authorList;
const categoryListEndpoint = ApiEndpoints.category.categoryList;
const tagListEndpoint = ApiEndpoints.tags.tagList;
const userName = !localStorage.getItem("username") ? "Admin" : localStorage.getItem("username");

export default function AddBlogAdmin() {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [tags, setTags] = useState([]);

  const [previews, setPreviews] = useState({ image: null, section_image: null, section_image2: null, section_image3: null,});

  const [postData, setPostData] = useState({ category_id: "", author_id: "", tag1: "", listing_page_description: "", short_description: "", name: "", slug: "", image: null, section_image: null, section_image2: null, section_image3: null, createdBy: userName, date: new Date(), description1: "", description2: "", heading1: "", heading2: "",});

  const regionsData = [
    { _id: "middle-east", name: "Middle East" },
    { _id: "america", name: "America" },
    { _id: "africa", name: "Africa" },
    { _id: "uk-and-europe", name: "UK & Europe" },
    { _id: "apac", name: "APAC" },
  ]

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        setCategories(response?.blog_categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategories([]);
      }
    };

    const fetchAuthors = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        setAuthors(response?.authors || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setAuthors([]);
      }
    };

    const fetchTags = async () => {
      try {
        const response = await ApiRequest("GET", tagListEndpoint);
        setTags(response?.tags || []);
      } catch (error) {
        console.error("Failed to fetch tags:", error);
        setTags([]);
      }
    };

    fetchCategories();
    fetchAuthors();
    fetchTags();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
    if (files) {
      const file = files[0];  
      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));
  
      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file, 
      }));
    } else {
      // For non-file inputs, update the postData state directly
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
 
  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (!["brief", "listing_page_description", "short_description"].includes(key) && (value === "" || value === null)) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", addBlogEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.error) {
        toast.error(response.message);
        return;
      }
      toast.success(response.message);
      navigate("/blog");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to create blog.");
    }
  };

  // Dynamic Sections State
   const [sectionCount, setSectionCount] = useState(2); 

    const handleAddMore = (e) => {
    e.preventDefault();
    if (sectionCount >= 10) {
      toast.warning("You can only add up to 10 sections.");
      return;
    }

    setSectionCount((prev) => {
        const newCount = prev + 1;

        // initialize new fields in postData
        setPostData((prevData) => ({
          ...prevData,
          [`heading${newCount}`]: "",
          [`description${newCount}`]: "",
        }));

        return newCount;
      });
    };

    const handleRemove = (id) => {
      if (id <= 2) return;

      setSectionCount((prev) => prev - 1);

      setPostData((prevData) => {
        const newData = { ...prevData };
        delete newData[`heading${id}`];
        delete newData[`description${id}`];
        return newData;
      });
    };

    const pagename = {
      name: 'Blog Management',
      user: 'Admin',
      innerpage: 'Blog Management / Blog / Add Blog'
    }

  return (
    <>
      <AdminHeader pagename={pagename}/>
      
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="name" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"category_id"} options={categories} placeholder="Select Category" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="Enter Author Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="author_id" options={authors} placeholder="Select Author Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Tag Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="tag1" options={tags} placeholder="Select Tag Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Listing Page Description</label>
                  </div>
                  <input
                    onChange={handleChange}
                    name="listing_page_description"
                    type="text"
                    className="form-control"
                    placeholder="Enter Listing Page Description"
                    value={postData.listing_page_description}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Short Description</label>
                  </div>
                  <input
                    onChange={handleChange}
                    name="short_description"
                    type="text"
                    className="form-control"
                    placeholder="Enter Short Description"
                    value={postData.short_description}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              {Array.from({ length: sectionCount }, (_, i) => i + 1).map((id) => (
                <div key={id} className="col-lg-6">
                  <div className="add-page-inputs">
                    <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                      <label>Heading {id}{id <= 2 && <small>*</small>}</label>
                      {id > 2 && (
                        <button type="button" className="remove-btn" onClick={() => handleRemove(id)}>Remove</button>
                      )}
                    </div>
                    <input onChange={handleChange} name={`heading${id}`} type="text" className="form-control" placeholder="Enter Heading" value={postData[`heading${id}`] || ""}/>
                  </div>

                  <div className="add-page-inputs">
                    <div className="label-wrap-add">
                      <label>Description {id}{id <= 2 && <small>*</small>}</label>
                    </div>
                    <DynamicCKEditor data={postData[`description${id}`] || ""}
                      onChange={(event, editor) => handleEditorChange(`description${id}`, editor.getData())}/>
                  </div>
                </div>
              ))}

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMore}>Add More +</Link>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (1200 × 638)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.section_image}
                    />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Listing Image (400 × 480)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="image"
                    // maxSize={550 * 1024}
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.image}/>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Image 1 (580 × 446)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section_image2"
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.section_image2}
                    />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Image 2 (580 × 446)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section_image3"
                    acceptedFormats={[".webp"]} 
                    onImageChange={handleChange}
                    imagePreview={previews.section_image3}/>
                </div>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
